import React, { lazy, Suspense } from 'react';
import { Route, Redirect } from 'react-router-dom';
import Loading from 'components/shared-components/Loading';

export const SettingsViews = () => {
  return (
    <Suspense fallback={<Loading cover="content" fallback={true} />}>
      <>
        <Route path={'/settings/user-preferences/profile'} exact component={lazy(() => import('./settings/user-preferences/profile'))} />
        <Route path={'/settings/user-preferences/notifications'} exact component={lazy(() => import('./settings/user-preferences/notifications'))} />
        <Route path={'/settings/user-preferences/security'} exact component={lazy(() => import('./settings/user-preferences/security'))} />
        <Route path={'/settings/account'} exact component={lazy(() => import('./settings/account'))} /> 
        <Route path={'/settings/requests'} exact component={lazy(() => import('./settings/requests'))} />
        <Route path={'/settings/clients'} exact component={lazy(() => import('./settings/clients'))} /> 
        <Route path={'/settings/quotes'} exact component={lazy(() => import('./settings/quotes'))} />
        <Route path={'/settings/jobs'} exact component={lazy(() => import('./settings/jobs'))} />
        <Route path={'/settings/invoices'} exact component={lazy(() => import('./settings/invoices'))} />
        <Route path={'/settings/employees'} exact component={lazy(() => import('./settings/employees'))} />
        <Route path={'/settings/employees/new'} exact component={lazy(() => import('./settings/employees/employees/new'))} />
        <Route path={'/settings/employees/:employee_id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})'} component={lazy(() => import('./settings/employees/employees/detail'))} />
        <Route path={'/settings/price-book'} exact component={lazy(() => import('./settings/price-book'))} />
        <Route path={'/settings'} exact component={lazy(() => import('./settings'))} />
      </>
    </Suspense>
  )
}

export default React.memo(SettingsViews);